// Moved to packages/backend/infraContracts (consumed by both the SST mgmt route wiring and
// app code). Re-exported here to keep existing consumers stable.
export * from '@omnea-app/packages/backend/infraContracts/publicApiMgmtEndpoints'
